import { render, staticRenderFns } from "./CustomerData.vue?vue&type=template&id=3d23265b&scoped=true&"
import script from "./CustomerData.vue?vue&type=script&lang=js&"
export * from "./CustomerData.vue?vue&type=script&lang=js&"
import style0 from "./CustomerData.vue?vue&type=style&index=0&id=3d23265b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d23265b",
  null
  
)

export default component.exports